import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


/**
 * Width directive change the width of the html element
 * Its goal is to avoid the multitude of class css creation
 * Exemple :
 * <div witdh=100%></div>
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[width]',
})
export class WizWidthDirective implements OnInit {
  @Input() width: string;

  constructor(private elementRef: ElementRef, private  renderer: Renderer2) {
  }

  ngOnInit(): void {

    try{
      this.renderer.setStyle(this.elementRef.nativeElement, 'width', this.width);
      // init flex-shrink
      // flex-shrink property defines the shrinkage factor of a flexible element
      if (this.width.indexOf( 'px' ) > -1) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'min-width', this.width);
        //this.renderer.setStyle(this.elementRef.nativeElement, 'flex-shrink', 0);
      }
    } catch(e: any) {
      // console.log('dir height', e, this);
    }

  }
}
